import { createSelector } from "reselect";

export const getApoio = (state) => state.apoio;
